import React, { useEffect, useRef } from 'react'
import { TempusDominus, Namespace } from '@eonasdan/tempus-dominus';
import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.css";
import icons from './icons'
import { parse, format } from 'date-fns'


function TimePicker({ id, value, onChange, timeFormat, isInvalid, ...props }) {
  const ref = useRef(null)

  useEffect(() => {
    const target = document.getElementById(id)
    if(!target) return
    if(target.hasAttribute("has-date-picker")) return

    const elem = new TempusDominus(target, {
      display: {
        viewMode: 'clock',
        icons,
        components: {
          decades: false,
          year: false,
          month: false,
          date: false,
          hours: true,
          minutes: true,
          seconds: false
        },
      },
      localization: {
        format: "hh:mm T",
      },
    })

    const subscriptions = elem.subscribe(
      [Namespace.events.show, Namespace.events.hide],
      [pickerDidShow, pickerDidHide]
    )


    return () => {
      subscriptions.forEach(subscription => subscription.unsubscribe())
      if(target.hasAttribute("has-date-picker")) {
        target.removeAttribute("has-date-picker")
      }
    }
  }, [id])

  function handleChange(e) {
    const { value } = e.target
    onChange(value)
  }



  function pickerDidShow(e) {
  }

  function pickerDidHide(e) {
    const { date } = e
    if(date) {
      const formatted = format(date, timeFormat)
      onChange(formatted)
    }
    else {
      onChange('')
    }
  }

  return (
    <input
      ref={ref}
      id={id}
      value={value}
      onChange={handleChange}
      className={`form-control ${isInvalid ? 'is-invalid' : ''} ${props.className || ''}`}
      type="text"
      {...props}
    />
  )
}

export default TimePicker
